module.exports = __webpack_public_path__ + "img/partner-teamwork.a52579c0.webp";